import React from 'react';
import styled from 'styled-components';
import images from 'rc-images';
import { BoxTitle, Description } from './common';
import Button from '../Button';
import ButtonText from '../ButtonText';

const Container = styled.div`
  background-color: white;
  box-shadow: 0 2px 12px 0px rgba(0,0,0,0.15);
  border-radius: 10px;
  padding: 80px 60px 20px 20px;
  margin: 15px 0;
  position: relative;
  margin-top: 170px;

  @media screen and (min-width: 866px) {
    padding: 83px 60px 20px 20px;
  }

  @media screen and (min-width: 768px) and (max-width: 865px) {
    padding: 64px 60px 20px 20px;
  }

  &:before{
    content: '';
    background-image: url(${images.testCoachling});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    width: 100%;
    height: 310px;
    position: absolute;
    top: -200px;
    left: 0;
    right: 0;
  }
`;

const AtHome = () => (
  <Container>
    <BoxTitle style={{ color: '#37a9ce' }}>
      Recycling at Home
    </BoxTitle>
    <Description>
      Get personalized schedules, pick-up reminders and more!
    </Description>
    <Button tabIndex="0" style={{ marginTop: 20 }} onClick={() => window.open('https://recyclecoach.com')}>
      <ButtonText tabIndex="-1">
        Learn more
      </ButtonText>
    </Button>
  </Container>
);

export default AtHome;
